var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuHamburg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.04395 12.1739C9.04395 11.5258 9.56976 11 10.2179 11H29.7831C30.4336 11 30.957 11.5258 30.957 12.1739C30.957 12.8245 30.4336 13.3478 29.7831 13.3478H10.2179C9.56976 13.3478 9.04395 12.8245 9.04395 12.1739ZM9.04395 20C9.04395 19.3495 9.56976 18.8261 10.2179 18.8261H29.7831C30.4336 18.8261 30.957 19.3495 30.957 20C30.957 20.6505 30.4336 21.1739 29.7831 21.1739H10.2179C9.56976 21.1739 9.04395 20.6505 9.04395 20ZM29.7831 29H10.2179C9.56976 29 9.04395 28.4766 9.04395 27.8261C9.04395 27.1755 9.56976 26.6522 10.2179 26.6522H29.7831C30.4336 26.6522 30.957 27.1755 30.957 27.8261C30.957 28.4766 30.4336 29 29.7831 29Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuHamburg);
export default __webpack_public_path__ + "static/media/MenuHamburg.5aa07d527e817d58a3f23d7ac00c458b.svg";
export { ForwardRef as ReactComponent };